export function round2(value) {
  return Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
}

export function isInactiveEstimateRow(row = {}) {
  return Boolean(
    row.inactive === true ||
      row.excluded === true ||
      row?.flags?.inactive === true ||
      row?.flags?.excluded === true ||
      row?.meta?.inactive === true ||
      row?.meta?.excluded === true
  );
}

export function getEstimateRowQuantity(row = {}) {
  return Number(row.quantity ?? row.qty ?? row.hours ?? 0);
}

export function getEstimateRowUnitPrice(row = {}) {
  return Number(
    row.unitPrice ?? row.price ?? row.hourlyRate ?? row.rate ?? 0
  );
}

export function getEstimateRowTotal(row = {}) {
  if (Number.isFinite(Number(row.total))) {
    return Number(row.total);
  }

  return getEstimateRowQuantity(row) * getEstimateRowUnitPrice(row);
}

export function calculateEstimateTotals(estimate = {}) {
  const materials = Array.isArray(estimate.materials) ? estimate.materials : [];
  const labour = Array.isArray(estimate.labour) ? estimate.labour : [];
  const extras = Array.isArray(estimate.extras) ? estimate.extras : [];

  const activeMaterials = materials.filter((row) => !isInactiveEstimateRow(row));
  const activeLabour = labour.filter((row) => !isInactiveEstimateRow(row));
  const activeExtras = extras.filter((row) => !isInactiveEstimateRow(row));

  const inactiveRows = [...materials, ...labour, ...extras].filter(
    isInactiveEstimateRow
  );

  const materialsSubtotal = round2(
    activeMaterials.reduce((sum, row) => sum + getEstimateRowTotal(row), 0)
  );

  const labourSubtotal = round2(
    activeLabour.reduce((sum, row) => sum + getEstimateRowTotal(row), 0)
  );

  const extrasSubtotal = round2(
    activeExtras.reduce((sum, row) => sum + getEstimateRowTotal(row), 0)
  );

  const inactiveTotal = round2(
    inactiveRows.reduce((sum, row) => sum + getEstimateRowTotal(row), 0)
  );

  const marginPercent = Number(
    estimate?.summary?.marginPercent ??
      estimate?.summary?.margin_percent ??
      estimate?.meta?.marginPercent ??
      25
  );

  const vatRate = Number(
    estimate?.summary?.vatRate ??
      estimate?.summary?.vat_rate ??
      estimate?.meta?.vatRate ??
      0.25
  );

  const vatPercent = round2(vatRate * 100);

  const baseCost = round2(materialsSubtotal + labourSubtotal + extrasSubtotal);
  const marginAmount = round2(baseCost * (marginPercent / 100));
  const subtotal = round2(baseCost + marginAmount);
  const vat = round2(subtotal * vatRate);
  const vatAmount = vat;
  const total = round2(subtotal + vat);

  return {
    materialsSubtotal,
    labourSubtotal,
    extrasSubtotal,
    inactiveTotal,
    baseCost,
    marginPercent,
    marginAmount,
    subtotal,
    vatRate,
    vatPercent,
    vat,
    vatAmount,
    total,
    activeRowsCount:
      activeMaterials.length + activeLabour.length + activeExtras.length,
    inactiveRowsCount: inactiveRows.length,
  };
}